import { render, staticRenderFns } from "./RoomWelcomeMeeting.vue?vue&type=template&id=6d2aca66&scoped=true"
import script from "./RoomWelcomeMeeting.vue?vue&type=script&lang=js"
export * from "./RoomWelcomeMeeting.vue?vue&type=script&lang=js"
import style0 from "./RoomWelcomeMeeting.vue?vue&type=style&index=0&id=6d2aca66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2aca66",
  null
  
)

export default component.exports